/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecutiveSummary
 */
export interface ExecutiveSummary {
    /**
     * 
     * @type {number}
     * @memberof ExecutiveSummary
     */
    totalInitiatives?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutiveSummary
     */
    onTrackCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutiveSummary
     */
    redInitiativeCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutiveSummary
     */
    amberInitiativeCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutiveSummary
     */
    greenInitiativeCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutiveSummary
     */
    riskFlagsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutiveSummary
     */
    belowFloorCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutiveSummary
     */
    chronicOverdueCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecutiveSummary
     */
    validationGapCount?: number;
}

/**
 * Check if a given object implements the ExecutiveSummary interface.
 */
export function instanceOfExecutiveSummary(value: object): value is ExecutiveSummary {
    return true;
}

export function ExecutiveSummaryFromJSON(json: any): ExecutiveSummary {
    return ExecutiveSummaryFromJSONTyped(json, false);
}

export function ExecutiveSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutiveSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'totalInitiatives': json['totalInitiatives'] == null ? undefined : json['totalInitiatives'],
        'onTrackCount': json['onTrackCount'] == null ? undefined : json['onTrackCount'],
        'redInitiativeCount': json['redInitiativeCount'] == null ? undefined : json['redInitiativeCount'],
        'amberInitiativeCount': json['amberInitiativeCount'] == null ? undefined : json['amberInitiativeCount'],
        'greenInitiativeCount': json['greenInitiativeCount'] == null ? undefined : json['greenInitiativeCount'],
        'riskFlagsCount': json['riskFlagsCount'] == null ? undefined : json['riskFlagsCount'],
        'belowFloorCount': json['belowFloorCount'] == null ? undefined : json['belowFloorCount'],
        'chronicOverdueCount': json['chronicOverdueCount'] == null ? undefined : json['chronicOverdueCount'],
        'validationGapCount': json['validationGapCount'] == null ? undefined : json['validationGapCount'],
    };
}

export function ExecutiveSummaryToJSON(json: any): ExecutiveSummary {
    return ExecutiveSummaryToJSONTyped(json, false);
}

export function ExecutiveSummaryToJSONTyped(value?: ExecutiveSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalInitiatives': value['totalInitiatives'],
        'onTrackCount': value['onTrackCount'],
        'redInitiativeCount': value['redInitiativeCount'],
        'amberInitiativeCount': value['amberInitiativeCount'],
        'greenInitiativeCount': value['greenInitiativeCount'],
        'riskFlagsCount': value['riskFlagsCount'],
        'belowFloorCount': value['belowFloorCount'],
        'chronicOverdueCount': value['chronicOverdueCount'],
        'validationGapCount': value['validationGapCount'],
    };
}

